import React, { useState } from "react";
import { Row, Col, Spin, Form, Card, DatePicker, InputNumber, Select } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "../treasuryContractBooking.config";
import { BOM } from "../../../services/definedMethod";

const AddSettlement = (props) => {
  const [form]         = Form.useForm();
  const [isLoading,    setIsLoading]    = useState(false);
  const [tradeOptions, setTradeOptions] = useState([]);
  const navigate       = useNavigate();

  const onFinish = async (values) => {
    try {
      setIsLoading(true);

      const payload = {
        tradeId:           values.tradeId,
        settlementDate:    values.settlementDate?.format("YYYY-MM-DD"),
        cashAmount:        values.cashAmount,
        securityFaceValue: values.securityFaceValue,
      };

      // await BOM.SendReq(apiConfig.createSettlement, payload);
      console.log("AddSettlement payload:", payload);
      BOM.AlertMsg(cnt.SUCCESS, "Settlement created successfully.");
      navigate(-1);
    } catch (error) {
      BOM.AlertMsg(cnt.DANGER, error?.message || "Failed to create settlement.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainLayout pageItems={staticConfig.manageSettlement}>
      <TopContent pageTitle={labelConfig.settlement} />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card style={{ boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)", borderRadius: 20 }}>
            <h3 style={{ marginBottom: 24, fontWeight: 600 }}>Create Settlement</h3>

            <Form layout="vertical" form={form} onFinish={onFinish}>

              {/* Trade & Settlement Date */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={<span>Trade <Tooltip title="The trade this settlement is linked to."><InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} /></Tooltip></span>}
                    name="tradeId"
                    rules={[{ required: true, message: "Trade is required" }]}
                  >
                    <Select
                      style={{ height: 44 }}
                      suffixIcon={<ChevronDown color="#667085" />}
                      options={tradeOptions}
                      placeholder="Select Trade"
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={<span>Settlement Date <Tooltip title="The date on which this settlement is due to occur."><InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} /></Tooltip></span>}
                    name="settlementDate"
                    rules={[{ required: true, message: "Settlement date is required" }]}
                  >
                    <DatePicker style={{ width: "100%", height: 44 }} format="YYYY-MM-DD" placeholder="YYYY-MM-DD" />
                  </Form.Item>
                </Col>
              </Row>

              {/* Cash Amount & Security Face Value */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={<span>Cash Amount <Tooltip title="The cash leg of the settlement — the actual amount to be paid or received."><InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} /></Tooltip></span>}
                    name="cashAmount"
                    rules={[
                      { required: true, message: "Cash amount is required" },
                      { type: "number", min: 1, message: "Cash amount must be greater than 0" },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%", height: 44 }}
                      placeholder="e.g. 49,250,000.00"
                      formatter={(v) => (v ? `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "")}
                      parser={(v) => v?.replace(/,/g, "")}
                      precision={2}
                      min={0}
                    />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={<span>Security Face Value <Tooltip title="The nominal face value of the securities being delivered or received."><InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} /></Tooltip></span>}
                    name="securityFaceValue"
                    rules={[
                      { required: true, message: "Security face value is required" },
                      { type: "number", min: 1, message: "Security face value must be greater than 0" },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%", height: 44 }}
                      placeholder="e.g. 50,000,000.00"
                      formatter={(v) => (v ? `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "")}
                      parser={(v) => v?.replace(/,/g, "")}
                      precision={2}
                      min={0}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }} />

              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{ height: 44, padding: "0 24px", borderRadius: 8, border: "1px solid #D0D5DD", background: "#fff", color: "#344054", fontWeight: 600, fontSize: 14, cursor: "pointer", marginRight: 12 }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{ height: 44, padding: "0 24px", borderRadius: 8, border: "1px solid #BA24D5", background: "#BA24D5", color: "#fff", fontWeight: 600, fontSize: 14, cursor: "pointer" }}
                  >
                    Submit
                  </button>
                </Col>
              </Row>

              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({ rightBtn: state.RightSideBtn });
export default connect(mapStateToProps, { rightAction })(AddSettlement);